import { decodeJwt } from 'jose'

export const decodeToken = (token) => {
    if (token) {
        return decodeJwt(token)
    }
    return null
}

export const getRefreshTokenInterval = (lifespan = 5) =>  {
    // refresh token earlier than the expiration time
    const refreshTimer = .5
    return refreshTimer * lifespan
}

export const getTokenExpiration = (token) => {
    try {
        // Decode the JWT token to extract the payload
        const decoded = decodeToken(token);

        // Extract the 'expiration' claim (expiration time in Unix timestamp)
        const expTimestamp = decoded.expiration;

        // Get the current Unix timestamp (in seconds)
        const currentTimestamp = Math.floor(Date.now() / 1000);

        // Calculate the remaining time in seconds
        const remainingSeconds = expTimestamp - currentTimestamp;

        // Convert the remaining time to minutes
        const remainingMinutes = remainingSeconds / 60;

        return remainingMinutes;
    } catch (error) {
        console.debug(`REFTOKEN: Error decoding the JWT token: ${error}`);
        return null;
    }
}

export const getNewRefreshTime = (minutes) => {
    return new Date(Date.now() + (minutes * 60 * 1000)).toISOString();
};